<template>
  <div class="card card-row shadow-light-lg mb-6">
    <div class="row no-gutters">
      <div
        class="col-12 col-md-6 bg-cover card-img-left who-we"
        :style="{
          backgroundImage: 'url(' + bgImage + ')',
        }"
      >
        <div
          class="shape shape-right shape-fluid-y svg-shim text-white d-none d-md-block"
        >
          <svg
            viewBox="0 0 112 690"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M116 0H51v172C76 384 0 517 0 517v173h116V0z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="card-body">
          <h2>Who we are</h2>
          <p class="mb-0 text-muted">
            With offices in Boston and in Israel, Ne’eman Foundation, a
            registered 501c3 charity, provides Americans with a wide selection
            of tax-deductible projects in Israel that are monitored to guarantee
            that allocated funds are used accordingly and comply with the
            requirements of I.R.S. USA tax legislation.
          </p>
          <p class="mb-0 text-muted">
            Ne’eman Foundation provides timely transfers of funds to Israel,
            thus enabling Israeli non-profit organizations to implement their
            projects expeditiously.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    bgImage() {
      return this.$store.state.country == "us"
        ? require("@/assets/img/boston.jpg")
        : require("@/assets/img/toronto.jpg");
    },
  },
};
</script>
<style lang="scss">
.card-img-left.who-we {
  min-height: 200px;
}
</style>